import React from "react";
import styled from "styled-components";
import withTheme from "../../hoc/withTheme";
import withLocalization from "../../hoc/withLocalization";
import { ENGLISH, ARABIC } from "../../state/actions/localization.action";
import ar from "../../localization/ar";
import en from "../../localization/en";

const Localbutton = props => {
  const { i18n, setEnglish, setArabic, theme } = props;

  const handleToggle = () => {
    switch (i18n.name) {
      case ENGLISH:
        setArabic();
        break;
      case ARABIC:
      default:
        setEnglish();
        break;
    }
  };

  return (
    <Container theme={theme} onClick={handleToggle}>
      {i18n.name === ENGLISH ? ar.sign : en.sign}
    </Container>
  );
};

const Container = styled.div`
  background: ${props => props.theme.colors.primary.normal};
  color: ${props => props.theme.colors.primary.text};
  width: 40px;
  height: 40px;
  font-weight: bold;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px;
`;

export default withLocalization(withTheme(Localbutton));
